import React, { Component } from 'react'
import './RefundsReturns.css';
import LayoutWrapper from '../../component/LayoutWrapper/'
import Footer from '../../component/Footer/Footer';

import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';


class RefundsReturns extends Component {
    constructor(props){
        super(props);
        this.state={
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    render() {
        return (
            <React.Fragment>
                <LayoutWrapper />

                <main className="main main-container">

                    <nav aria-label="breadcrumb" className="breadcrumb-nav">
                        <div className="container">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Refunds & Returns policies</li>
                            </ol>
                        </div>
                        {/* End .container */}
                    </nav>
                    <div className="elementor-widget-container ctnr">
                        <h2 className="elementor-heading-title elementor-size-default">Refunds & Returns policies</h2>
                    </div>
                    <div className="elementor-text-editor elementor-clearfix bdr rr ">
                        <h3 className="pg top-hg">
                            <span style={{"fontWeight": "400"}}>
                            Conditions of Website use (“Terms”). If You do not agree to these Terms or any changes to these Terms, please immediately discontinue Your use of the Website.
                            </span>
                        </h3>
                        
                        <h3 className="pg">
                            Online Return Policy
                        </h3>
                        <div className="pg">
                            <span style={{"fontWeight": "400"}}>
                                Regular priced merchandise in its original, undamaged and unused condition, with its original tags and packaging, may be returned for refund within 7 days of the order date, plus applicable shipment time. Sale merchandise in its original, undamaged and unused condition, may be returned for refund within 14 days of the order date, plus applicable shipment time. All returns and exchanges must be accompanied by the shipment email or packing slip. Items marked as Final Sale cannot be returned or exchanged.

                                <p className="p_1">
                                    For reasons of hygiene and the personal safety of our customers, we regret that the following items may not be returned: boxer shorts, underwear and swimwear. Items that do not comply with this return policy will be sent back to you.
                                </p>

                                <p className="p_1"> 
                                    StyleCabbie does not give price adjustments on previously purchased merchandise. Items marked as Final Sale cannot be returned or exchanged.
                                </p>
                            </span>
                        </div>
                        
                        <h3 className="pg ftr">
                        <a className="customer-care" href="/privacy-policy">Return Guidelines</a>
                        </h3>
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                Eligible returns can be made by mailed back using the prepaid return labels in your shipment(s). The local post office  prepaid return label must be clearly affixed to the outside of the box. The return form, including reason for the return, must be included inside the box with the merchandise being returned. Please keep the return tracking number for your records. Refunds will not be processed until the merchandise is received by StyleCabbie in accordance with our Return Policy.

                                {/* <p className="p_1">Once StyleCabbie receives your return and determines that it complies with this Online Return Policy, we will refund the cost of your merchandise, plus applicable taxes, to your SC Wallet. Please allow 2 business days from the receipt of your return at our fulfillment centres for processing and up to 5 business days for the refund to be posted to your credit card and if paid via COD then the return will be in your SC Wallet.</p> */}

                                <p className="p_1">we will refund amount to your credit card.</p> 

                                <p className="p_1">
                                    StyleCabbie will not be liable for any returns received that do not comply with the return requirements. Returns that do not comply with the return requirements will be sent back to the original shipping address on the order. If this package remains unclaimed, we will not issue a refund. Any additional shipping of this product will be at the purchaser’s expense.
                                </p>
                            </span>
                        </div>
                        
                        <h3 className="pg ftr">
                            How to Return
                        </h3> 
                        <p className="pg">Returns by mail:</p> 
                        <ul className="ul pg line-ht">
                            <li>Complete the return form included with your online order, marking the details of the item(s) returned and reason(s) for the return.</li>
                            <li>Enclose the return form with the merchandise to be returned in the box.</li>
                            <li>Pack items safely, peel off the prepaid shipping label and affix it to the outside of the box.</li>
                            <li>Mark your postal code on the return shipping label in the space provided and retain the tracking number for your records.</li>
                            <li>Take your package to your nearest Post Office drop off location or We will arrange a pick-up within 2-3 days of your request (additional charges may include)</li>
                            <li>Payment Gateway refund process takes 7 to 9 working days excluding Saturdays/Sundays and Bank Holidays.</li>
                        </ul>
                          
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                Only items purchased on <a className="customer-care" href="/">StyleCabbie.com</a> can be returned by mail.
                            </span>
                        </div>                        
                        <h3 className="pg ftr">
                            Exchanges
                        </h3>
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                Subject to item availability, item(s) purchased at StyleCabbie.com<a className="customer-care" href="/">StyleCabbie.com</a> may be exchanged via mail. 

                                <p className="p_1">
                                    Merchandise returned must be in accordance with StyleCabbie’s Online Return Policy.
                                </p>
                            </span>
                        </div>
                        
                        {/* <h3 className="pg ftr">
                            Gift Orders
                        </h3>
                        <div className="pg">
                            <span style={{"fontWeight": "300"}}>
                                Online gift orders may be returned by mail. Merchandise received as a gift must be in accordance with StyleCabbie’s Online Return Policy and will require an order number, a pack slip, or shipping confirmation as proof of purchase.
                            </span>
                        </div> 
                        <p className="pg">Returns by mail:</p>                    
                        <p className="p_1 pg">Online gift orders returned by mail will be refunded back to the original method of payment. The Payment Gateway refund process takes 7 to 9 working days excluding Saturdays/Sundays and Bank Holidays and read the <b>Return Guidelines.</b></p> */}
                    </div>
                </main>
                <Footer />
            </React.Fragment>
        )
    }
}
export default  RefundsReturns 
